/*
 * Показ ошибки сервера человеку.
 *
 * Отдельный помощник нужен из-за пределов подписки: сервер отвечает на них
 * кодом 402 и отметкой `premium-limit`, и такой отказ должен приходить
 * с дверью, а не с одной стеной. Упереться в предел и не увидеть, как его
 * снять, — худший вид отказа: человек считает, что приложение сломалось.
 */

import { ApiError } from '$api/client';
import { toasts } from '$stores/toasts.svelte';
import { ui } from '$stores/ui.svelte';

/** Отказ из-за предела учётной записи, который снимается подпиской. */
export function isPremiumLimit(error: unknown): boolean {
	return error instanceof ApiError && error.details?.reason === 'premium-limit';
}

/**
 * Сообщить об ошибке. Текст берётся у сервера — он знает, какой именно
 * предел исчерпан и каково его значение; выдумывать его здесь значило бы
 * завести второй источник тех же чисел.
 */
export function reportError(error: unknown, fallback: string, prefix = ''): void {
	const text = prefix + (error instanceof Error ? error.message : fallback);

	if (isPremiumLimit(error)) {
		toasts.error(text, { label: 'Подключить', run: () => ui.openPremium() });
		return;
	}

	toasts.error(text);
}
